import { render } from "./IconSubstack.vue?vue&type=template&id=7127fc52"
import script from "./IconSubstack.vue?vue&type=script&lang=js"
export * from "./IconSubstack.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__